/*
 * @Description: 教务数据管理
 */
import { RouteRecordRaw } from 'vue-router'

const panelDataScreenRouter: Array<RouteRecordRaw> = [
    {
        path: '/panelDataScreen',
        component: () => import(/* webpackChunkName: "panelDataScreen" */ '@/views/dataAnalysis/panelDataScreen/index.vue'),
        name: 'panelDataScreen',
        meta: { title: '数据大屏' }
    },
    {
        path: '/panelDataScreenEdit',
        component: () => import(/* webpackChunkName: "panelDataScreenEdit" */ '@/views/dataAnalysis/panelDataScreen/eidt.vue'),
        name: 'panelDataScreenEdit',
        meta: { title: '编辑数据大屏' }
    }
]

export default panelDataScreenRouter
